import { del, get, post, put } from '@/redux/requests/api.js';
import normalizeRequestFailure from '@/redux/requests/lib/normalizeRequestFailure.js';

const REQUEST_BY_METHOD = {
  DELETE: del,
  GET: get,
  POST: post,
  PUT: put
};

const requestSharedWorkspaceJson = ({ method = 'GET', url, token, query = undefined, data = undefined, callback = undefined, loader = undefined, signal = undefined, headers = undefined, fallbackMessage = undefined, transformSuccess = undefined } = {}) => {
  const normalizedMethod = String(method || 'GET')
    .trim()
    .toUpperCase();
  const requestMethod = REQUEST_BY_METHOD[normalizedMethod] || get;

  return requestMethod(url, {
    authToken: token,
    callback,
    loader,
    signal,
    query,
    data,
    headers: {
      'x-mindcloud-instance': 'pieve-web',
      ...(headers || {})
    },
    onResponse: (responseShape) => {
      const nextResponseShape = normalizeRequestFailure({
        responseShape,
        fallbackMessage
      });

      if (nextResponseShape?.data?.success !== true) {
        return nextResponseShape;
      }

      if (typeof transformSuccess === 'function') {
        return transformSuccess(nextResponseShape) || nextResponseShape;
      }

      return nextResponseShape;
    }
  });
};

export default requestSharedWorkspaceJson;
